import React, { useState } from "react";
import Reveal from "./ui/Reveal";
import SectionLabel from "./ui/SectionLabel";

const QUESTIONS = [
  {
    q: "Preciso instalar alguma coisa no computador?",
    a: "Não. O PawSuite roda 100% no navegador — funciona em computador, tablet e celular. Basta acessar com seu login de qualquer lugar, inclusive de casa.",
  },
  {
    q: "Meus dados e os dos meus clientes ficam seguros?",
    a: "Sim. Tudo fica armazenado na nuvem com backup automático, e cada funcionário só enxerga o que a permissão dele permite. Você controla quem acessa o quê.",
  },
  {
    q: "Consigo migrar minha planilha atual?",
    a: "Sim. Na visita técnica avaliamos como seus dados de clientes, pets e serviços estão organizados hoje e ajudamos na importação para o sistema.",
  },
  {
    q: "Minha equipe vai conseguir usar?",
    a: "O treinamento de equipe está incluído em todos os planos. O sistema foi desenhado a partir do fluxo real de um pet shop, então a curva de aprendizado é curta — na prática, quem já usa agenda de papel se adapta rápido.",
  },
  {
    q: "Existe fidelidade ou multa de cancelamento?",
    a: "Não há fidelidade. Você pode cancelar a qualquer momento, sem multa e sem taxa de instalação para começar.",
  },
  {
    q: "O sistema serve para clínica veterinária ou só para banho e tosa?",
    a: "Serve para os dois. Há módulo de prontuário clínico com histórico de vacinas e atendimentos, e módulo de banho & tosa com controle de tempos, taxi-dog e pacotes.",
  },
];

const FaqItem = ({ item, isOpen, onToggle, index }) => (
  <Reveal delay={index * 70}>
    <div
      className={`overflow-hidden rounded-2xl border transition-all duration-500 ${
        isOpen
          ? "border-tealVitality/25 bg-white shadow-soft"
          : "border-midnight/[.07] bg-white/60 hover:border-midnight/15 hover:bg-white"
      }`}
    >
      <button
        onClick={onToggle}
        aria-expanded={isOpen}
        className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left"
      >
        <span
          className={`font-display text-base font-bold transition-colors duration-300 sm:text-lg ${
            isOpen ? "text-tealVitality" : "text-midnight"
          }`}
        >
          {item.q}
        </span>

        <span
          className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-all duration-500 ${
            isOpen
              ? "rotate-45 bg-tealVitality text-white"
              : "bg-midnight/[.06] text-midnight/50"
          }`}
        >
          <svg
            className="h-4 w-4"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 5v14M5 12h14" />
          </svg>
        </span>
      </button>

      <div className={`accordion-body ${isOpen ? "open" : ""}`}>
        <div>
          <p className="px-6 pb-6 leading-relaxed text-midnight/60">{item.a}</p>
        </div>
      </div>
    </div>
  </Reveal>
);

const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="relative overflow-hidden bg-white py-28">
      <div className="pointer-events-none absolute -right-40 top-1/3 h-[420px] w-[420px] rounded-full bg-tealVitality/[.07] blur-[120px]" />

      <div className="relative mx-auto max-w-4xl px-6">
        <div className="mb-16 text-center">
          <Reveal>
            <SectionLabel tone="amber">Perguntas frequentes</SectionLabel>
          </Reveal>
          <Reveal delay={90}>
            <h2 className="mb-5 mt-6 font-display text-[clamp(2rem,4.2vw,3rem)] font-extrabold leading-[1.08] text-midnight">
              Tirando as dúvidas
              <br className="hidden sm:block" /> antes de começar
            </h2>
          </Reveal>
          <Reveal delay={170}>
            <p className="text-lg text-midnight/55">
              Não achou o que procurava? Fale com a gente no WhatsApp — responde
              gente de verdade.
            </p>
          </Reveal>
        </div>

        <div className="space-y-3">
          {QUESTIONS.map((item, i) => (
            <FaqItem
              key={item.q}
              item={item}
              index={i}
              isOpen={open === i}
              onToggle={() => setOpen(open === i ? -1 : i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
